'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

/**
 * Resets scroll to the top on landing-page navigation. The landing shell lives in the (persistent)
 * layout and swaps its body BY PATHNAME rather than through Next's `children`, so Next's built-in
 * scroll-to-top doesn't fire — without this, clicking e.g. Pricing after scrolling down leaves the
 * new page scrolled to the same offset. Skips back/forward (POP) so the browser's own scroll
 * restoration keeps working, and skips hash links so in-page anchors still land where they should.
 */
export function LandingScrollReset() {
    const pathname = usePathname()
    const firstRender = useRef(true)
    const poppedRef = useRef(false)

    useEffect(() => {
        const onPopState = () => {
            poppedRef.current = true
        }
        window.addEventListener('popstate', onPopState)
        return () => window.removeEventListener('popstate', onPopState)
    }, [])

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false
            return
        }
        if (poppedRef.current) {
            // Back / forward — let the browser restore the previous scroll position.
            poppedRef.current = false
            return
        }
        if (window.location.hash) return // let #anchors scroll themselves
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}
